import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};
export function CtaButton({
  children,
  href = '#pricing',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg rounded-2xl' : 'px-5 py-3 text-sm rounded-xl';
  return <a href={href} className={`group inline-flex items-center justify-center gap-2 bg-terracotta hover:bg-terracotta-dark text-white font-bold tracking-wide shadow-card hover:shadow-lift transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-4 focus-visible:ring-terracotta/30 ${sizing} ${className}`} data-id="element-95" data-mp="qjikrtxvt433">
      {children}
      <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-96" data-mp="19as40uxgf77v" />
    </a>;
}